import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";
import { User } from "../../_models/user";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-admin-dunzo-create',
  templateUrl: './admin-dunzo-create.component.html',
  styleUrls: ['./admin-dunzo-create.component.scss'],
})
export class AdminDunzoCreateComponent implements OnInit {

  carrierName: string;
  carrierNameError: string;
  clientSecret: string;
  clientSecretError: string;
  clientId: string;
  clientIdError: string;

  constructor(private alertService: AlertService, private g: Globals, private user: User, private http: HttpClient, private router: Router, private route: ActivatedRoute) {

  }


  carrierNameBlur() {
    this.carrierNameError = "";
    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
  }

  clientSecretBlur() {
    this.clientSecretError = "";
    if (!this.clientSecret) {
      this.clientSecretError = 'Please enter clientSecret';
    }
  }

  clientIdBlur() {
    this.clientIdError = "";
    if (!this.clientId) {
      this.clientIdError = 'Please enter clientId';
    }
  }


  ngOnInit() { }

  verify() {

    this.g.loaderDisplay = "display";
    this.carrierNameError = "";
    this.clientIdError = "";
    this.clientSecretError = "";

    if (!this.carrierName) {
      this.carrierNameError = 'Please enter carrier name';
    }
    if (!this.clientSecret) {
      this.clientSecretError = 'Please enter clientSecret';
    }
    if (!this.clientId) {
      this.clientIdError = 'Please enter clientId';
    }
    if (this.carrierNameError != "" || this.clientSecretError != "" || this.clientIdError != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    // api body

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/verifyAndSaveCarrierCredentials', {

      "carrierCode": "DN",
      "connectionName": this.carrierName,
      "organizationId": 1,
      "clientId": this.clientId,
      "clientSecret": this.clientSecret

    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Dunzo', 'Create Successfully');
          this.router.navigate(['/admin/adminCarriers']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
          console.log(err);
        })
  }
}
